<template>
  <YuliActivity></YuliActivity>
</template>
<script>
import YuliActivity from '@/components/YuliActivity' 
export default {
  components:{
    YuliActivity,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
